$(function ($) {

  $( document ).on( 'click', '[data-toggle="offcanvas"]', function () {

    var btn       =  $( this );
    var offcanvas = $( btn.attr( 'data-target' ) );
    var main      = $( '.main' );

    btn.toggleClass( 'active' );
    offcanvas.toggleClass( 'active' );
    main.toggleClass( 'menu-active' );

    $( 'html, body' ).animate( {
      scrollTop: $( $(this).attr( 'href' ) ).offset().top - 200
    }, 750 );

  });

});
